<div id="{{ createAttributeIdForConfigurator(attribute) }}" class="cx-row">
  <div
    *ngFor="let value of attribute.values; let i = index"
    id="{{ createAttributeValueIdForConfigurator(attribute, value.valueCode) }}"
    class="cx-configurator-select"
  >
    <input
      id="{{
        createAttributeValueIdForConfigurator(attribute, value.valueCode) +
          '-input'
      }}"
      type="checkbox"
      class="form-input"
      [value]="value.valueCode"
      [formControl]="attributeCheckBoxForms[i]"
      name="{{ createAttributeIdForConfigurator(attribute) }}"
      (click)="onSelect(i)"
      [attr.aria-labelledby]="
        createValueUiKey('label', attribute.name, value.valueCode)
      "
      [attr.aria-checked]="attributeCheckBoxForms[i].value"
      [cxFocus]="{ key: attribute.name + '-' + value.name }"
    />
    <div class="cx-label-container">
      <label
        id="{{ createValueUiKey('label', attribute.name, value.valueCode) }}"
        for="{{
          createAttributeValueIdForConfigurator(attribute, value.valueCode) +
            '-input'
        }}"
        class="form-check-label"
      >
        <img
          *ngIf="value.images[0]"
          class="cx-img"
          src="{{ value.images[0].url }}"
          alt="{{ value.images[0].altText }}"
        />
        <div *ngIf="!value.images[0]" class="cx-img-dummy"></div>
        {{ value.valueDisplay }}
        <cx-configurator-price
          [formula]="extractValuePriceFormulaParameters(value)"
        ></cx-configurator-price>
      </label>
    </div>
  </div>
</div>
